import React from 'react'
import CourseBatchDetail from '../../../modules/ClassLearner/Detail'

const CourseBatchDetailPage = () => {
  return <CourseBatchDetail />
}

export default CourseBatchDetailPage
